module.exports = __webpack_public_path__ + "media/pdf_missing/motor-55b26cfe.svg";